import React, { useEffect } from 'react';
import { LuLock, LuShieldCheck, LuHardDrive, LuImage, LuDroplets, LuDownload } from 'react-icons/lu';
import PublicLayout from './PublicLayout';

export default function Security() {
  useEffect(() => {
    document.title = 'Security | Photo Harbor';
  }, []);

  return (
    <PublicLayout>
      {/* Hero */}
      <section className="lp-hero" style={{ paddingBottom: '2rem' }}>
        <div className="lp-hero-inner">
          <div className="lp-trust-icon" style={{ margin: '0 auto 1.5rem', width: 56, height: 56 }}>
            <LuLock size={28} />
          </div>
          <h1 className="lp-h1">Security & Data Handling</h1>
          <p className="lp-hero-sub">How we keep your photos safe.</p>
        </div>
      </section>

      {/* Encryption */}
      <section className="lp-features" style={{ paddingTop: '2rem' }}>
        <div className="lp-section-inner">
          <div className="lp-section-head">
            <h2>Encryption & access</h2>
          </div>
          <div className="lp-features-grid" style={{ maxWidth: 900, margin: '0 auto' }}>
            {[
              { icon: LuLock, title: 'Encrypted in transit', desc: 'All connections use HTTPS (TLS) to encrypt data between you and our servers.' },
              { icon: LuHardDrive, title: 'Encrypted at rest', desc: 'Server-side encryption is applied to stored photo data on eligible plans.' },
              { icon: LuShieldCheck, title: 'Access controls', desc: 'Production access is limited to authorized personnel. All access is logged.' }
            ].map((item) => (
              <div key={item.title} className="lp-feature-card">
                <div className="lp-feature-icon"><item.icon size={20} /></div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What we do with photos */}
      <section className="lp-trust">
        <div className="lp-section-inner">
          <div className="lp-section-head">
            <h2>What we do with your photos</h2>
          </div>
          <div className="lp-trust-grid">
            {[
              { icon: LuImage, title: 'Store originals', desc: 'We store your original high-resolution files and generate smaller variants for speed.' },
              { icon: LuLock, title: 'Private by default', desc: 'Your galleries are private. You control sharing and download options.' },
              { icon: LuShieldCheck, title: 'Never sold', desc: 'We never sell your photos or use them for advertising or AI training.' },
              { icon: LuHardDrive, title: 'Secure deletion', desc: 'On deletion, originals and generated variants are queued for secure removal.' }
            ].map((item) => (
              <div key={item.title} className="lp-trust-card">
                <div className="lp-trust-icon"><item.icon size={22} /></div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Watermarks & Downloads */}
      <section className="lp-features">
        <div className="lp-section-inner">
          <div className="lp-features-grid" style={{ maxWidth: 600, margin: '0 auto' }}>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuDroplets size={20} /></div>
              <h3>Watermarking</h3>
              <p>Apply watermarks to shared views on supported plans to protect your work.</p>
            </div>
            <div className="lp-feature-card">
              <div className="lp-feature-icon"><LuDownload size={20} /></div>
              <h3>Download controls</h3>
              <p>Toggle downloads per gallery or share link. Add expirations for extra safety.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="lp-trust">
        <div className="lp-section-inner">
          <div className="lp-section-head">
            <h2>Frequently asked questions</h2>
          </div>
          <div className="lp-features-grid" style={{ maxWidth: 900, margin: '0 auto' }}>
            {[
              { title: 'Do you keep originals?', desc: 'Yes. Originals are preserved. We also create optimized variants (sm/md/lg/xl) for fast delivery.' },
              { title: 'Are my photos encrypted?', desc: 'All traffic is encrypted via HTTPS. Server-side encryption at rest is applied on Pro and higher tiers.' },
              { title: 'Do you back up my photos?', desc: 'Automatic backups are included with Pro, Studio, and higher plans with increasing frequency and retention.' },
              { title: 'Can you use my photos for marketing?', desc: 'No. We do not sell or use your photos for advertising or training. Your content remains yours.' },
              { title: 'What happens when I delete a photo?', desc: 'The original and generated variants are scheduled for deletion and removed from shares.' },
              { title: 'More questions?', desc: 'Email support@dailey.photos and we\'ll get back to you within 24 hours.' }
            ].map((item) => (
              <div key={item.title} className="lp-feature-card">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
